import {
  productFamilyIdFormat,
  productFamilyOptionIdFormat,
  productFamilyOptionValueIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import { AttributeSchema } from "@redotech/redo-model/inventory/attributes";
import { ListingsWithStatusSchema } from "@redotech/redo-model/inventory/listing-status";
import * as z from "zod/v4";

const ImageSchema = z.object({
  id: z.string(),
  url: z.string(),
  alt_text: z.string(),
  position: z.number(),
});

const ProductPriceSchema = z.object({
  productId: productIdFormat.schema,
  price: z.number(),
  currency: z.string(),
});

const ProductOptionValueInputSchema_ = z.object({
  id: productFamilyOptionValueIdFormat.schema.optional(),
  value: z.string().min(1),
});
export const ProductOptionValueInputSchema: z.ZodType<ProductOptionValueInput> =
  ProductOptionValueInputSchema_;
export interface ProductOptionValueInput
  extends z.infer<typeof ProductOptionValueInputSchema_> {}

const ProductOptionInputSchema_ = z.object({
  id: productFamilyOptionIdFormat.schema.optional(),
  name: z.string().min(1),
  values: z.array(ProductOptionValueInputSchema_),
});
export const ProductOptionInputSchema: z.ZodType<ProductOptionInput> =
  ProductOptionInputSchema_;
export interface ProductOptionInput
  extends z.infer<typeof ProductOptionInputSchema_> {}

export const updateProductFamily = {
  name: "updateProductFamily" as const,
  input: z.object({
    productFamilyId: productFamilyIdFormat.schema,
    title: z.string().optional(),
    description: z.string().optional(),
    vendor: z.string().nullable().optional(),
    tags: z.array(z.string()).optional(),
    attributes: z.array(AttributeSchema).optional(),
    images: z.array(ImageSchema).optional(),
    productPrices: z.array(ProductPriceSchema).optional(),
    productOptions: z.array(ProductOptionInputSchema_).optional(),
    listings: ListingsWithStatusSchema,
  }),
  output: z.object({
    success: z.boolean(),
  }),
};
